import React from 'react';
import ItemForm from '../ItemForm';
import PropertyForm from '../PropertyForm';
import ServiceRequestForm from '../ServiceRequestForm';
import ContactForm from 'src/components/ContactForm/ContactForm';
import { IContactFormData } from 'src/SharedCustomHooks/UseContactFormData/types';

interface WizardBodyProps {
  active: string;
  onBack: () => void;
  onClose: () => void;
  onSubmitContactForm: (
    formData: IContactFormData,
    formType: string
  ) => Promise<void>;
  saveProperty: (data: any, actionType?: any) => void;
  onSaveItem: (item: any) => void;
  tabList: any;
}

const WizardBody = ({
  active,
  onBack,
  onClose,
  onSubmitContactForm,
  saveProperty,
  onSaveItem,
  tabList,
}: WizardBodyProps) => {
  switch (active) {
    case 'Service Request':
      return (
        <ServiceRequestForm
          onClose={onBack}
          onExit={onClose}
          from={undefined}
          serviceRequest={undefined}
        />
      );
    case 'Property':
      return (
        <PropertyForm
          onClose={onBack}
          onSaveProperty={saveProperty}
          tabList={tabList}
        />
      );
    case 'Contact':
      return (
        <ContactForm
          onClose={onBack}
          onSubmit={onSubmitContactForm}
          sendActivationLinkToUser={undefined}
          sendResetPasswordLinkToUser={undefined}
        />
      );
    case 'Item':
      return <ItemForm onClose={onBack} onSaveItem={onSaveItem} />;
    default:
      return null;
  }
};

export default WizardBody;
